export default __webpack_public_path__ + "static/6b6141_hapAC-0716eabefa9f8a5407b87b28b66e624d.jpg";